export default __webpack_public_path__ + "static/media/1.b5ec3bab.png";